<template>
  <div class="nto-status-data">
    <div
      v-for="event in eventsList"
      :key="event.key"
      class="nto-status-data-item"
    >
      <div class="nto-status-data-item-icon">
        <svg-loader :src="event.icon" />
      </div>

      <div class="nto-status-data-item-label">
        {{ event.label }}
      </div>

      <div class="nto-status-data-item-value">
        {{ event.value }}
      </div>

      <div class="nto-status-data-item-reference-label">
        {{ event.referenceLabel }}
      </div>
    </div>
  </div>
</template>

<script>
import { TraceabilityStatus } from '@/enums'

import {
  traceabilityStatusLabels,
  traceabilityStatusAlternativeNamesMap,
  traceabilityExceptionalStatusLabels
} from '@/constants'

const referenceLabel = {
  [TraceabilityStatus.NotReceived]: 'Amostras',
  [TraceabilityStatus.Triage]: 'Amostras',
  [TraceabilityStatus.InExecution]: 'Amostras',
  [TraceabilityStatus.InRelease]: 'Exames',
  [TraceabilityStatus.ReportReleased]: 'Exames',
  [TraceabilityStatus.RecalledText]: 'Exames',
  [TraceabilityStatus.PendingCreatedText]: 'Amostras',
  [TraceabilityStatus.Canceled]: 'Amostras',
}

export default {
  name: 'NtoStatusData',
  props: {
    events: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      enabledEvents: [
        TraceabilityStatus.Triage,
        TraceabilityStatus.InExecution,
        TraceabilityStatus.PendingCreatedText,
        TraceabilityStatus.InRelease,
        TraceabilityStatus.ReportReleased,
        TraceabilityStatus.Canceled,
        TraceabilityStatus.RecalledText
      ],
    }
  },
  computed: {
    eventsList() {
      return this.events
        .filter(event => {
          const statusName = traceabilityStatusAlternativeNamesMap[event.statusName] ?? event.statusName

          return this.enabledEvents.includes(statusName)
        })
        .map(event => {
          const statusName = traceabilityStatusAlternativeNamesMap[event.statusName] ?? event.statusName

          return {
            key: statusName,
            label: traceabilityStatusLabels[statusName] ?? traceabilityExceptionalStatusLabels[statusName],
            value: event.total,
            referenceLabel: referenceLabel[statusName],
            icon: `/static/images/icon-traceability-event-${statusName}.svg`
          }
        })
    }
  },
}
</script>

<style lang="scss" scoped>
.nto-status-data {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  font-family: 'Exo 2';
  padding: 1rem;
  flex-basis: 100%;
  position: relative;

  &::before {
    content: '';
    left: 1rem;
    right: 1rem;
    height: 3px;
    z-index: 1;
    background-color: #EC2072;
    top: 37px; // 1.5px is the half of the height of the line
    transform: translateY(-50%);
    display: block;
    position: absolute;
  }

  & > div:first-child, & > div:last-child {
    &::before {
      content: '';
      left: 0;
      width: 50%;
      height: 6px;
      z-index: 1;
      background-color: #FFF;
      top: 20px; // 1.5px is the half of the height of the line
      transform: translateY(-50%);
      display: block;
      position: absolute;
    }
  }

  & > div:last-child {
    &::before {
      right: 0;
      left: auto;
    }
  }

  &-item {
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    position: relative;
    padding-left: 1rem;
    padding-right: 1rem;
    width: 140px;

    &-icon {
      border: 2px solid #EC2072;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-bottom: 7px;
      color: #EC2072;
      background: white;
      z-index: 2;
      position: relative;
    }

    &-label {
      font-weight: 700;
      font-size: 0.83rem;
      color: #7F1A54;
      text-align: center;
    }

    &-value {
      font-weight: 700;
      font-size: 2rem;
      color: #EC2072;
      text-align: center;
      margin: 5px 0;
    }

    &-reference-label {
      font-weight: 400;
      font-size: 0.875rem;
      color: #7F1A54;
      text-align: center;
    }
  }

  &-item:first-child::before {
    display: none;
  }
}
</style>
